<template>
  <div>
    <card title="Users" :subtitle="''">
      <div>
        <Users-Table/>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  name: 'Users-Card'
}
</script>

<style>

</style>